import React, { Suspense, lazy } from 'react';
import Layout from '../components/Layout/Layout';
import { useTheme } from './ThemeProvider';

// Lazy-load Theme 2 layout so its CSS/JS only ships when the theme is active.
const Theme2Layout = lazy(() => import('./theme2/Theme2Layout'));

/**
 * Renders the appropriate site shell (header/footer/background) for the
 * currently active theme. Theme 1 uses the original, untouched Layout.
 */
const ThemedLayout = ({ children }) => {
  const { isTheme2 } = useTheme();

  if (isTheme2) {
    return (
      <Suspense fallback={<Layout>{children}</Layout>}>
        <Theme2Layout>{children}</Theme2Layout>
      </Suspense>
    );
  }

  return <Layout>{children}</Layout>;
};

export default ThemedLayout;
